import { get, writable } from 'svelte/store';
import { MessageType, Role } from '../types';
import { v4 } from 'uuid';
import { assert, deepCompare, getAssignedActiveConversations, identity } from './util';
export class ConversationStore {
    constructor(conversationRemoteRepository, addMessage) {
        this.conversationRemoteRepository = conversationRemoteRepository;
        this.addMessage = addMessage;
        this.store = writable([]);
        this.subscribe = this.store.subscribe;
    }
    update(conversations) {
        const previous = get(this.store);
        if (!deepCompare(conversations, previous)) {
            this.store.set(conversations);
        }
    }
    async createConversation(client) {
        const conversation = {
            id: v4(),
            client: client,
            operator: undefined,
            createDate: new Date()
        };
        let savedConversation = await this.conversationRemoteRepository.addConversation(conversation);
        this.store.update(conversations => [...conversations, savedConversation]);
        return savedConversation;
    }
    async startConversation(conversation, operator) {
        assert(operator.roles.includes(Role.OPERATOR));
        const conversations = get(this.store);
        const assignedActiveConversations = getAssignedActiveConversations(operator, conversations);
        for (let assignedActiveConversation of assignedActiveConversations) {
            await this.endConversation(assignedActiveConversation, operator);
        }
        const savedConversation = await this.conversationRemoteRepository.startConversation(conversation, operator);
        Object.assign(conversation, savedConversation);
        this.store.update(identity);
    }
    async pauseConversation(conversation) {
        const savedConversation = await this.conversationRemoteRepository.pauseConversation(conversation);
        Object.assign(conversation, savedConversation);
        this.store.update(identity);
    }
    async unpauseConversation(conversation) {
        const savedConversation = await this.conversationRemoteRepository.unpauseConversation(conversation);
        Object.assign(conversation, savedConversation);
        this.store.update(identity);
    }
    async endConversation(conversation, author) {
        assert(this.conversationEndDialog);
        const endDialogResult = await this.conversationEndDialog.open(conversation);
        const message = {
            id: v4(),
            conversationId: conversation.id,
            authorId: endDialogResult.author.id,
            type: MessageType.CLOSING,
            text: endDialogResult.messageText,
            createDate: new Date()
        };
        await this.addMessage(message);
        const savedConversation = await this.conversationRemoteRepository.endConversation(conversation);
        Object.assign(conversation, savedConversation);
        this.store.update(identity);
    }
    async archiveConversation(conversation) {
        const savedConversation = await this.conversationRemoteRepository.archiveConversation(conversation);
        Object.assign(conversation, savedConversation);
        this.store.update(identity);
    }
    async registerConversationEndDialog(conversationEndDialog) {
        this.conversationEndDialog = conversationEndDialog;
    }
}
